import React, { Fragment, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { formatDbDateWithoutTime } from '../../../utils/dateFormater';
import { useSelector } from 'react-redux';
import Loader from '../../loader/loader';
import DefaultAvatar from "../../images/default_avatar.jpg"
import { formatWhatsAppNumber } from '../../../utils/whatsappLinkFormater';
import HoverFullText from '../../../elements/HoverToolKit';
import SingleProductButtons from './SingleProductButtons';
const SingleProduct = ({
    product,
    index,
    totalProducts,
    user,
    page,
    selectedProdcuts,
    setSelectedProdcuts
}) => {




    const [searchParams] = useSearchParams();
    const perPage = searchParams.get("perPage");

    const [copied, setCopied] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);



    const { loading } = useSelector(state => state.inviteUser)


    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const handleDownload = async (imageUrl) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `product-${product.id || 'image'}.jpg`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error("Failed to download image:", error);
            window.open(imageUrl, '_blank');
        }
    };




    const displayIndex = String(
        totalProducts - ((page - 1) * Number(perPage) + index)
    ).padStart(2, '0');















    const handleClassName = (ProductStatus) => {


        if (ProductStatus === "ACTIVE") return "text-green-600 bg-green-100";
        if (ProductStatus === "SYSTEM_CANCELLED") return "text-red-600 bg-red-100";
        if (ProductStatus === "SUSPENDED") return "text-orange-600 bg-orange-100";
        if (ProductStatus === "INACTIVE") return "text-purple-600 bg-purple-100";
        if (ProductStatus === "PAUSED") return "text-orange-600 bg-orange-100";

    }





    return (
        <Fragment>
            {loading && <Loader />}
            <div className="flex py-[1vmax] min-w-max border-b border-gray-200 hover:bg-gray-50 transition-colors relative" >
                {user?.role !== "PM" &&
                    <div className="text-center flex-center items-center w-[60px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax]" >
                        <input
                            type="checkbox"
                            checked={selectedProdcuts?.includes(product.id)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedProdcuts(prev => [...prev, product.id]);
                                } else {
                                    setSelectedProdcuts(prev => prev.filter(id => id !== product.id));
                                }
                            }}
                        />
                    </div>
                }
                <div className="text-center flex-center items-center w-[50px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax]" >
                    {displayIndex}
                </div>

                {user?.role !== "PMM"
                    &&
                    <div className="flex-center flex-col px-[0.5vmax] w-[80px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                        <a href={formatWhatsAppNumber(product?.country_code, product?.phone_number)} target="_blank" rel="noopener noreferrer" className="mb-[0.5vmax]">
                            &nbsp;&nbsp;<i className="fa-brands fa-whatsapp text-green-600 text-[1.8vmax] lg:text-[1.2vmax]"></i>
                        </a>

                        <div>{String(product.seller_pmm_id)?.padStart(2, '0')}</div>
                    </div>
                }
                {user?.role !== "PM" && (
                    <div className="flex-center flex-col px-[0.5vmax] w-[120px] flex-shrink-0 text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                        <HoverFullText text={product?.seller_type || "N/A"} sliceLength={15} />
                    </div>
                )}
                <div className="flex-center flex-col px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    <HoverFullText text={product?.market} sliceLength={13} />
                </div>
                <div className="flex-center px-[0.5vmax] w-[180px] flex-shrink-0 text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    <HoverFullText text={product?.keywords} sliceLength={16} />
                </div>
                <div className="flex-center px-[0.5vmax] w-[80px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    {product.overall_sales_limit || 0}
                </div>
                <div className="flex-center px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    {product.overall_limit_left || 0}
                </div>
                <div className="flex-center px-[0.5vmax] w-[130px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    {product.today_limt_left || 0}
                </div>
                <div className="flex-center px-[0.5vmax] w-[170px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    <span className='capitalize' >Rs</span>. {product.pm_commission || 0}
                </div>
                <div className="flex-center flex-col px-[0.5vmax] w-[180px] flex-shrink-0 text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] " >
                    <div className={`
                        px-[0.8vmax] py-[0.2vmax] rounded-full font-bold text-[1.1vmax] lg:text-[0.8vmax] shadow-sm
                        ${product?.product_type_name?.toLowerCase().includes("text") ? "bg-blue-100 text-blue-600 border border-blue-200" :
                            product?.product_type_name?.toLowerCase().includes("picture") ? "bg-green-100 text-green-600 border border-green-200" :
                                product?.product_type_name?.toLowerCase().includes("video") ? "bg-purple-100 text-purple-600 border border-purple-200" :
                                    "bg-gray-100 text-gray-600 border border-gray-200"}
                    `}>
                        <HoverFullText text={product?.product_type_name} sliceLength={13} />
                    </div>
                </div>
                <div className="flex-center px-[0.5vmax] w-[140px] flex-shrink-0 text-[#4c4c5c] text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    <div className="flex">
                        <div className="text-gray-600 text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                            {product.id}
                        </div>
                        &nbsp;&nbsp;
                        <button
                            onClick={() => handleCopy(product.seller_id)}
                            className="flex items-center gap-1 text-sm"
                            title={copied ? "Copied" : "Copy"}
                        >
                            <i
                                className={`fa-regular ${copied ? "fa-circle-check text-green-600" : "fa-copy"
                                    } text-[1.4vmax] lg:text-[0.8vmax]`}
                            ></i>
                        </button>
                    </div>
                </div>
                <div className="px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] flex gap-[1vmax] items-center justify-center" >
                    <div className="w-[6vmax] max-h-[6vmax] lg:w-[3.5vmax] lg:max-h-[3.5vmax] flex-center overflow-hidden rounded-lg cursor-pointer" title="Click to view" onClick={() => setShowImageModal(true)}>
                        <img src={product?.custom_image || DefaultAvatar} alt="" className="w-full rounded-lg hover:scale-105 transition-transform" />
                    </div>
                </div>
                <div className="flex-center px-[0.5vmax] w-[140px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-medium" >
                    {formatDbDateWithoutTime(product.created_at)}
                </div>
                <div className={`flex-center px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] `} >
                    <span className={`text-center text-[1.6vmax] lg:text-[0.8vmax] inline-block p-[0.2vmax_0.5vmax] font-semibold ${handleClassName(product.status)} `} >
                        {product.status?.replaceAll("_", " ").toUpperCase()}
                    </span>
                </div>
                <SingleProductButtons product={product} user={user} />
            </div>

            {showImageModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/75 backdrop-blur-sm z-[99999999999] p-4" onClick={() => setShowImageModal(false)}>
                    <div className="relative max-w-[90vw] max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
                        <button 
                            className="absolute top-[-2vmax] right-[-2vmax] text-white text-[2vmax] hover:text-gray-300"
                            onClick={() => setShowImageModal(false)}
                        >
                            <i className="fa-solid fa-circle-xmark"></i>
                        </button>
                        <img src={product?.custom_image || DefaultAvatar} alt="Product" className="max-w-full max-h-[80vh] rounded-lg shadow-2xl" />
                        <div className="text-center mt-[1vmax]">
                            <button 
                                onClick={() => handleDownload(product?.custom_image || DefaultAvatar)}
                                className="bg-white text-gray-800 px-[1.5vmax] py-[0.5vmax] rounded-lg font-bold hover:bg-gray-100 transition-colors inline-flex items-center gap-2"
                            >
                                <i className="fa-solid fa-download"></i> Download
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </Fragment>
    )
}

export default SingleProduct


